
(function () {
    var TABLE_SELECTOR = '.rte table';
    var toastTemplate = null;

    function copyText(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
            document.execCommand('copy');
        } catch (e) {}
        document.body.removeChild(ta);
        return Promise.resolve();
    }

    function handleCopyCode(e, btn) {
        e.stopPropagation();
        const code = btn.querySelector('.copy-code-text')?.textContent.trim();
        const cell = btn.closest('.copy-code-matched');
        copyText(code).then(function () {
            cell.classList.add('is-copied');
            setTimeout(function () {
                cell.classList.remove('is-copied');
            }, 800);
            showToast(code);
        });
    }

    function showToast(message) {
        if (toastTemplate === null) {
            toastTemplate = document.getElementById('copy-toast-template') || false;
        }
        if (!toastTemplate) return;

        var toast = toastTemplate.content.firstElementChild.cloneNode(true);
        var textEl = toast.querySelector('.copy-toast-text');
        if (textEl) textEl.textContent = message;

        document.body.appendChild(toast);

        requestAnimationFrame(function () {
            toast.classList.add('is-visible');
        });

        setTimeout(function () {
            toast.classList.remove('is-visible');
            setTimeout(function () {
            toast.remove();
            }, 200);
        }, 1500);
    }

    function attachButton(element, index) {
        const text = element.textContent.trim();
        if (!text) return;
        element.dataset.copyChecked = index;
        element.classList.add('copy-code-matched');

        element.innerHTML = `
            <button
                class="copy-code-btn-wrap"
                role="button"
                tabindex="0"
                aria-label="Copy: ${text}"
            >
                <code><span class="copy-code-text">${text}</span></code>
                <span class="copy-code-icon">
                    <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <rect x="9" y="9" width="13" height="13" rx="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                </span>
            </button>
        `;
    }

    function activeEventCopyCode() {
        document.addEventListener('click', event => {
            const btn = event.target.closest('.copy-code-btn-wrap');
            if (!btn) return;
            handleCopyCode(event, btn);
        });
    }

    function init() {
        const tables = document.querySelectorAll(TABLE_SELECTOR);
        if (!tables.length) return;
        tables.forEach(table => {
            const hasTHead = table.querySelector('thead');
            const $tdEle = hasTHead ? table.querySelectorAll('tbody tr td:first-child') : table.querySelectorAll('tbody tr:nth-child(n+2) td:first-child');
            if (!$tdEle.length) return;
            $tdEle.forEach((element, index) => {
                attachButton(element, index);
            });
        });

        activeEventCopyCode();
    }

    init();
})();